import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/jc.png'


const _withScopeId = n => (_pushScopeId("data-v-e55607e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"text-align":"center"} }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "req" }, "*", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { style: {"text-align":"center"} }, "VGM数据", -1))
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "req" }, "*", -1))
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "form-table" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", { class: "form-table-td-count" }, [
  /*#__PURE__*/_createElementVNode("td", { width: "70" }),
  /*#__PURE__*/_createElementVNode("td", { width: "140" }),
  /*#__PURE__*/_createElementVNode("td")
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", { style: {"background-color":"rgb(223, 240, 216)","color":"blue","font-weight":"bolder","text-align":"center"} }, [
  /*#__PURE__*/_createElementVNode("td", { colspan: "3" }, "“发收通”信息是否需要填写，请咨询指定货代")
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  rowspan: "6",
  class: "label",
  style: {"vertical-align":"middle"}
}, [
  /*#__PURE__*/_createTextVNode(" 发货人"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("（Shipper） ")
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "label" }, "代码", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "label" }, "名称", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "label" }, "地址", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "label" }, "国家/地区代码", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "label" }, "电话", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "label" }, "AEO编码（选填）", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", { style: {"background-color":"rgb(242, 222, 222)","color":"blue","font-weight":"bolder","text-align":"center"} }, [
  /*#__PURE__*/_createElementVNode("td", { colspan: "3" }, " ↓↓↓若收货人名称为TO ORDER，则无需填写收货人其他信息，但TO ORDER必须填入“收货人名称”栏↓↓↓ ")
], -1))
const _hoisted_19 = {
  rowspan: "8",
  class: "label",
  style: {"vertical-align":"middle"}
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "label" }, "代码", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "label" }, "名称", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "label" }, "地址", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "label" }, "国家/地区代码", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "label" }, "电话", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "label" }, "AEO编码（选填）", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "label" }, "具体联系人", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "label" }, "联系人电话", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", { style: {"background-color":"rgb(242, 222, 222)"} }, [
  /*#__PURE__*/_createElementVNode("td", { colspan: "3" }, " ")
], -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  rowspan: "6",
  class: "label",
  style: {"vertical-align":"middle"}
}, [
  /*#__PURE__*/_createTextVNode(" 通知人"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("（Notifier） ")
], -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "label" }, "代码", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "label" }, "名称", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "label" }, "地址", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "label" }, "国家/地区代码", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "label" }, "电话", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "label" }, "AEO编码（选填）", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "1.\"VGM\"重量单位默认为KGS,如有不同计量单位，请换算成KGS再做填写", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "2..\"VGM责任方\"如不填为空，则默认为发货人", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "3. 称重方法:", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " M1-方法1:集装箱装好后，发货人或发货人委托第三方，对装好的集装箱总体称重 ", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " M2-方法2:发货人或者发货人委托的第三方，对所有货物重量/包装物重量，集装箱内的底盘、衬垫、其它系固材料，和集装箱本身重量， 累加计算的整体重量. ", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_miezz_input = _resolveComponent("miezz-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_miezz_select = _resolveComponent("miezz-select")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_WarningFilled = _resolveComponent("WarningFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_miezz_page_list = _resolveComponent("miezz-page-list")!
  const _component_miezz_button = _resolveComponent("miezz-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_miezz_card = _resolveComponent("miezz-card")!
  const _component_miezz_hscode = _resolveComponent("miezz-hscode")!
  const _component_miezz_modal = _resolveComponent("miezz-modal")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createBlock(_component_miezz_card, {
      fix: true,
      title: "舱单&VGM信息",
      "bottom-buttons": _ctx.buttons,
      onHandleFooterButtonClick: _ctx.handleClick
    }, {
      default: _withCtx(() => [
        (_ctx.form.Data)
          ? (_openBlock(), _createBlock(_component_el_form, {
              key: 0,
              model: _ctx.form.Data,
              ref: "ruleForm",
              rules: _ctx.form.Rules,
              "label-width": "200px"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_row, null, {
                  default: _withCtx(() => [
                    (_ctx.detail?.TransportType == _ctx.EnumTransportType.Sea)
                      ? (_openBlock(), _createBlock(_component_el_col, {
                          key: 0,
                          span: 8
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_form_item, {
                              label: "船名",
                              prop: "MainBill.ShipName"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_miezz_input, {
                                  modelValue: _ctx.form.Data.MainBill.ShipName,
                                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.Data.MainBill.ShipName) = $event)),
                                  red: _ctx.addDeparturePortBookingManifestVgm
                                }, null, 8, ["modelValue", "red"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.detail?.TransportType == _ctx.EnumTransportType.Sea)
                      ? (_openBlock(), _createBlock(_component_el_col, {
                          key: 1,
                          span: 8
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_form_item, {
                              label: "航次",
                              prop: "MainBill.VoyageNumber"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_miezz_input, {
                                  modelValue: _ctx.form.Data.MainBill.VoyageNumber,
                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.Data.MainBill.VoyageNumber) = $event)),
                                  red: _ctx.addDeparturePortBookingManifestVgm
                                }, null, 8, ["modelValue", "red"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.detail?.TransportType == _ctx.EnumTransportType.Air)
                      ? (_openBlock(), _createBlock(_component_el_col, {
                          key: 2,
                          span: 8
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_form_item, {
                              label: "航班",
                              prop: "MainBill.Flight"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_miezz_input, {
                                  modelValue: _ctx.form.Data.MainBill.Flight,
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.Data.MainBill.Flight) = $event)),
                                  red: _ctx.addDeparturePortBookingManifestVgm
                                }, null, 8, ["modelValue", "red"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.detail?.TransportType == _ctx.EnumTransportType.Railway)
                      ? (_openBlock(), _createBlock(_component_el_col, {
                          key: 3,
                          span: 8
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_form_item, {
                              label: "班次",
                              prop: "MainBill.RailwayNumber"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_miezz_input, {
                                  modelValue: _ctx.form.Data.MainBill.RailwayNumber,
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.Data.MainBill.RailwayNumber) = $event)),
                                  red: _ctx.addDeparturePortBookingManifestVgm
                                }, null, 8, ["modelValue", "red"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_el_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: "Port of Delivery/目的港",
                          prop: "MainBill.DeliveryPortId"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_miezz_select, {
                              modelValue: _ctx.form.Data.MainBill.DeliveryPortId,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.Data.MainBill.DeliveryPortId) = $event)),
                              label: _ctx.form.Data.MainBill.DeliveryPortLabel,
                              "onUpdate:label": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.Data.MainBill.DeliveryPortLabel) = $event)),
                              options: _ctx.deliveryPorts,
                              remote: true,
                              remoteMethod: _ctx.getDeliveryPorts,
                              red: _ctx.addDeparturePortBookingManifestVgm
                            }, null, 8, ["modelValue", "label", "options", "remoteMethod", "red"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: "Master Bill No.",
                          prop: "MainBill.MasterBillNo"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_miezz_input, {
                              modelValue: _ctx.form.Data.MainBill.MasterBillNo,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.Data.MainBill.MasterBillNo) = $event)),
                              pattern: "[0-9a-z-]",
                              upperCase: true,
                              trimAll: true,
                              red: _ctx.addDeparturePortBookingManifestVgm
                            }, null, 8, ["modelValue", "red"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createElementVNode("h2", _hoisted_1, [
                  _createTextVNode(" 明细品名及数据 "),
                  (_ctx.crossMixing)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        class: "cross-mixing",
                        href: "javascript:;",
                        style: {"text-decoration":"none"},
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.modalCrossMixing.Show = true))
                      }, [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_WarningFilled)
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" 出现交叉混拼，请核查 ")
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(_component_miezz_page_list, {
                  modelValue: _ctx.listProduct,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.listProduct) = $event)),
                  onHandleRowButtonClick: _ctx.handleProductRowButtonClick
                }, {
                  "column-header": _withCtx(({ model }) => [
                    (
              model.Prop == 'BLNO' ||
              model.Prop == 'ContainerNo' ||
              model.Prop == 'SealNo' ||
              model.Prop == 'ContainerTypeId' ||
              model.Prop == 'NameEn' ||
              model.Prop == 'HsCode' ||
              model.Prop == 'Quantity' ||
              model.Prop == 'PackagesKind' ||
              model.Prop == 'GrossWeight' ||
              model.Prop == 'Volume'
            )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                          _hoisted_3,
                          _createTextVNode(_toDisplayString(model.Label), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  column: _withCtx(({ model, row, index }) => [
                    (model.Prop == 'BLNO')
                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                          key: 0,
                          prop: `DetailProducts[${index}].BLNO`,
                          rules: _ctx.form.Rules.DetailProducts_BLNO,
                          "label-width": "0px"
                        }, {
                          default: _withCtx(() => [
                            (_ctx.departurePortDeclareCustoms)
                              ? (_openBlock(), _createBlock(_component_miezz_select, {
                                  key: 0,
                                  modelValue: row.CustomsId,
                                  "onUpdate:modelValue": ($event: any) => ((row.CustomsId) = $event),
                                  options: _ctx.customsPartBlNos,
                                  red: _ctx.addDeparturePortBookingManifestVgm,
                                  onHandleChange: ($event: any) => (_ctx.handleCustomsIdChange(row)),
                                  onHandleFocus: _cache[8] || (_cache[8] = (e) => _ctx.handleCustomsIdFocus(e))
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "red", "onHandleChange"]))
                              : (_openBlock(), _createBlock(_component_miezz_input, {
                                  key: 1,
                                  modelValue: row.BLNO,
                                  "onUpdate:modelValue": ($event: any) => ((row.BLNO) = $event),
                                  pattern: "[a-zA-Z0-9]",
                                  trimAll: true,
                                  upperCase: true
                                }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                          ]),
                          _: 2
                        }, 1032, ["prop", "rules"]))
                      : (model.Prop == 'ContainerNo')
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 1,
                            prop: `DetailProducts[${index}].ContainerNo`,
                            rules: _ctx.form.Rules.DetailProducts_ContainerNo,
                            "label-width": "0px"
                          }, {
                            default: _withCtx(() => [
                              (_ctx.departurePortContainer)
                                ? (_openBlock(), _createBlock(_component_miezz_select, {
                                    key: 0,
                                    modelValue: row.ContainerTrailerId,
                                    "onUpdate:modelValue": ($event: any) => ((row.ContainerTrailerId) = $event),
                                    options: _ctx.containerNos,
                                    red: _ctx.addDeparturePortBookingManifestVgm,
                                    onHandleChange: ($event: any) => (
                _ctx.handleContainerTrailerIdChange(row, 'Product', index)
              ),
                                    onHandleFocus: _cache[9] || (_cache[9] = (e) => _ctx.handleContainerTrailerIdFocus(e))
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "red", "onHandleChange"]))
                                : (
                _ctx.detail?.TransportContainerLoad ==
                  _ctx.EnumTransportContainerLoad.FCL && _ctx.containerNos.length > 0
              )
                                  ? (_openBlock(), _createBlock(_component_miezz_select, {
                                      key: 1,
                                      modelValue: row.ContainerNo,
                                      "onUpdate:modelValue": ($event: any) => ((row.ContainerNo) = $event),
                                      valueKey: "Label",
                                      options: _ctx.containerNos,
                                      red: _ctx.addDeparturePortBookingManifestVgm,
                                      onHandleChange: ($event: any) => (
                _ctx.handleContainerTrailerChange(row, 'Product', index)
              )
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "red", "onHandleChange"]))
                                  : (_openBlock(), _createBlock(_component_miezz_input, {
                                      key: 2,
                                      modelValue: row.ContainerNo,
                                      "onUpdate:modelValue": ($event: any) => ((row.ContainerNo) = $event),
                                      pattern: "[0-9a-z]",
                                      upperCase: true,
                                      onHandleBlur: ($event: any) => (_ctx.handleContainerTrailerChange(row, 'Product', index))
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "onHandleBlur"]))
                            ]),
                            _: 2
                          }, 1032, ["prop", "rules"]))
                        : (model.Prop == 'SealNo')
                          ? (_openBlock(), _createBlock(_component_el_form_item, {
                              key: 2,
                              prop: `DetailProducts[${index}].SealNo`,
                              rules: _ctx.form.Rules.DetailProducts_SealNo,
                              "label-width": "0px"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_miezz_input, {
                                  modelValue: row.SealNo,
                                  "onUpdate:modelValue": ($event: any) => ((row.SealNo) = $event),
                                  red: _ctx.addDeparturePortBookingManifestVgm,
                                  disabled: !row.ContainerNo,
                                  onHandleBlur: ($event: any) => (_ctx.handleSyncContainer(row, 'Product', index))
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "red", "disabled", "onHandleBlur"])
                              ]),
                              _: 2
                            }, 1032, ["prop", "rules"]))
                          : (model.Prop == 'ContainerTypeId')
                            ? (_openBlock(), _createBlock(_component_el_form_item, {
                                key: 3,
                                prop: `DetailProducts[${index}].ContainerTypeId`,
                                rules: _ctx.form.Rules.DetailProducts_ContainerTypeId,
                                "label-width": "0px"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_miezz_select, {
                                    modelValue: row.ContainerTypeId,
                                    "onUpdate:modelValue": ($event: any) => ((row.ContainerTypeId) = $event),
                                    label: row.ContainerTypeLabel,
                                    "onUpdate:label": ($event: any) => ((row.ContainerTypeLabel) = $event),
                                    options: _ctx.containerTypes,
                                    red: _ctx.addDeparturePortBookingManifestVgm,
                                    labelKey: "Data.Iso",
                                    onHandleChange: ($event: any) => (_ctx.handleSyncContainer(row, 'Product', index))
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "onUpdate:label", "options", "red", "onHandleChange"])
                                ]),
                                _: 2
                              }, 1032, ["prop", "rules"]))
                            : (model.Prop == 'NameEn')
                              ? (_openBlock(), _createBlock(_component_el_form_item, {
                                  key: 4,
                                  prop: `DetailProducts[${index}].NameEn`,
                                  rules: _ctx.form.Rules.DetailProducts_NameEn,
                                  "label-width": "0px"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_miezz_input, {
                                      modelValue: row.NameEn,
                                      "onUpdate:modelValue": ($event: any) => ((row.NameEn) = $event),
                                      "fetch-suggestions": (q, cb) => _ctx.getNameEns(row, q, cb),
                                      valueKey: "Name",
                                      pattern: "[a-zA-Z\\s]",
                                      trim: true,
                                      trimManySpace: true,
                                      disabled: !row.BLNO,
                                      red: _ctx.addDeparturePortBookingManifestVgm
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "fetch-suggestions", "disabled", "red"])
                                  ]),
                                  _: 2
                                }, 1032, ["prop", "rules"]))
                              : (model.Prop == 'HsCode')
                                ? (_openBlock(), _createBlock(_component_el_form_item, {
                                    key: 5,
                                    prop: `DetailProducts[${index}].HsCode`,
                                    rules: _ctx.form.Rules.DetailProducts_HsCode,
                                    "label-width": "0px"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_miezz_input, {
                                        modelValue: row.HsCode,
                                        "onUpdate:modelValue": ($event: any) => ((row.HsCode) = $event),
                                        onFocus: ($event: any) => (_ctx.onHsCode(row)),
                                        disabled: !row.NameEn,
                                        red: _ctx.addDeparturePortBookingManifestVgm
                                      }, null, 8, ["modelValue", "onUpdate:modelValue", "onFocus", "disabled", "red"])
                                    ]),
                                    _: 2
                                  }, 1032, ["prop", "rules"]))
                                : (model.Prop == 'Quantity')
                                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                                      key: 6,
                                      prop: `DetailProducts[${index}].Quantity`,
                                      rules: _ctx.form.Rules.DetailProducts_Quantity,
                                      "label-width": "0px"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_miezz_input, {
                                          modelValue: row.Quantity,
                                          "onUpdate:modelValue": ($event: any) => ((row.Quantity) = $event),
                                          number: true,
                                          pattern: "[0-9]",
                                          greaterThanNumber: 0,
                                          red: _ctx.addDeparturePortBookingManifestVgm
                                        }, null, 8, ["modelValue", "onUpdate:modelValue", "red"])
                                      ]),
                                      _: 2
                                    }, 1032, ["prop", "rules"]))
                                  : (model.Prop == 'PackagesKind')
                                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                                        key: 7,
                                        prop: `DetailProducts[${index}].PackagesKind`,
                                        rules: _ctx.form.Rules.DetailProducts_PackagesKind,
                                        "label-width": "0px"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_miezz_input, {
                                            modelValue: row.PackagesKind,
                                            "onUpdate:modelValue": ($event: any) => ((row.PackagesKind) = $event),
                                            "fetch-suggestions": _ctx.getPackageKinds,
                                            valueKey: "Label",
                                            red: _ctx.addDeparturePortBookingManifestVgm,
                                            "trigger-on-focus": true,
                                            deleteOption: true,
                                            checkDeleteOption: (it) => it.Data.IsHistory,
                                            onHandleDeleteOption: 
                (arg1, arg2) => _ctx.handleDeleteContact(arg1, arg2, row)
              
                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "fetch-suggestions", "red", "checkDeleteOption", "onHandleDeleteOption"])
                                        ]),
                                        _: 2
                                      }, 1032, ["prop", "rules"]))
                                    : (model.Prop == 'GrossWeight')
                                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                                          key: 8,
                                          prop: `DetailProducts[${index}].GrossWeight`,
                                          rules: _ctx.form.Rules.DetailProducts_GrossWeight,
                                          "label-width": "0px"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_miezz_input, {
                                              modelValue: row.GrossWeight,
                                              "onUpdate:modelValue": ($event: any) => ((row.GrossWeight) = $event),
                                              pattern: "[0-9.]",
                                              number: true,
                                              numberFixed: 2,
                                              greaterThanNumber: 0,
                                              red: _ctx.addDeparturePortBookingManifestVgm,
                                              onHandleBlur: _cache[10] || (_cache[10] = ($event: any) => (_ctx.calcVgmWeight()))
                                            }, null, 8, ["modelValue", "onUpdate:modelValue", "red"])
                                          ]),
                                          _: 2
                                        }, 1032, ["prop", "rules"]))
                                      : (model.Prop == 'Volume')
                                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                                            key: 9,
                                            prop: `DetailProducts[${index}].Volume`,
                                            rules: _ctx.form.Rules.DetailProducts_Volume,
                                            "label-width": "0px"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_miezz_input, {
                                                modelValue: row.Volume,
                                                "onUpdate:modelValue": ($event: any) => ((row.Volume) = $event),
                                                pattern: "[0-9.]",
                                                number: true,
                                                numberFixed: 4,
                                                greaterThanNumber: 0,
                                                red: _ctx.addDeparturePortBookingManifestVgm
                                              }, null, 8, ["modelValue", "onUpdate:modelValue", "red"])
                                            ]),
                                            _: 2
                                          }, 1032, ["prop", "rules"]))
                                        : (model.Prop == 'MarksNotes')
                                          ? (_openBlock(), _createBlock(_component_el_form_item, {
                                              key: 10,
                                              prop: `DetailProducts[${index}].MarksNotes`,
                                              "label-width": "0px"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_miezz_input, {
                                                  modelValue: row.MarksNotes,
                                                  "onUpdate:modelValue": ($event: any) => ((row.MarksNotes) = $event),
                                                  trim: false
                                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                              ]),
                                              _: 2
                                            }, 1032, ["prop"]))
                                          : (model.Prop == 'DangerUnCode')
                                            ? (_openBlock(), _createBlock(_component_el_form_item, {
                                                key: 11,
                                                prop: `DetailProducts[${index}].DangerUnCode`,
                                                "label-width": "0px"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_miezz_input, {
                                                    modelValue: row.DangerUnCode,
                                                    "onUpdate:modelValue": ($event: any) => ((row.DangerUnCode) = $event),
                                                    trim: false
                                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                                ]),
                                                _: 2
                                              }, 1032, ["prop"]))
                                            : (model.Prop == 'DangerCategory')
                                              ? (_openBlock(), _createBlock(_component_el_form_item, {
                                                  key: 12,
                                                  prop: `DetailProducts[${index}].DangerCategory`,
                                                  "label-width": "0px"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_miezz_input, {
                                                      modelValue: row.DangerCategory,
                                                      "onUpdate:modelValue": ($event: any) => ((row.DangerCategory) = $event),
                                                      trim: false
                                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                                  ]),
                                                  _: 2
                                                }, 1032, ["prop"]))
                                              : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["modelValue", "onHandleRowButtonClick"]),
                _createVNode(_component_miezz_button, {
                  model: _ctx.btnAddProduct,
                  onHandleClick: _ctx.handleClick
                }, null, 8, ["model", "onHandleClick"]),
                _hoisted_4,
                _createVNode(_component_miezz_page_list, {
                  modelValue: _ctx.listVgm,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.listVgm) = $event)),
                  onHandleRowButtonClick: _ctx.handleVgmRowButtonClick
                }, {
                  "column-header": _withCtx(({ model }) => [
                    (
              model.Prop == 'ContainerNo' ||
              model.Prop == 'SealNo' ||
              model.Prop == 'ContainerTypeId'
            )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                          _hoisted_6,
                          _createTextVNode(_toDisplayString(model.Label), 1)
                        ]))
                      : (model.Prop == 'WeighingMethod')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _createVNode(_component_el_icon, {
                              class: "weighing-method",
                              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.modalWeighingMethod.Show = true))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_WarningFilled)
                              ]),
                              _: 1
                            }),
                            _createTextVNode(" " + _toDisplayString(model.Label), 1)
                          ]))
                        : _createCommentVNode("", true)
                  ]),
                  column: _withCtx(({ model, row, index }) => [
                    (model.Prop == 'ContainerNo')
                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                          key: 0,
                          prop: `DetailVgms[${index}].ContainerNo`,
                          rules: _ctx.form.Rules.DetailVgms_ContainerNo,
                          "label-width": "0px"
                        }, {
                          default: _withCtx(() => [
                            (
                _ctx.departurePortContainer ||
                (_ctx.detail?.TransportContainerLoad ==
                  _ctx.EnumTransportContainerLoad.FCL &&
                  _ctx.containerNos.length > 0)
              )
                              ? (_openBlock(), _createBlock(_component_miezz_select, {
                                  key: 0,
                                  modelValue: row.ContainerTrailerId,
                                  "onUpdate:modelValue": ($event: any) => ((row.ContainerTrailerId) = $event),
                                  options: _ctx.vgmContainerNos,
                                  red: _ctx.addDeparturePortBookingManifestVgm,
                                  onHandleVisibleChange: 
                (show) => _ctx.handleContainerTrailerIdVisibleChange(show, row)
              ,
                                  onHandleChange: ($event: any) => (_ctx.handleContainerTrailerIdChange(row, 'Vgm', index)),
                                  onHandleFocus: _cache[13] || (_cache[13] = (e) => _ctx.handleContainerTrailerIdFocus(e))
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "red", "onHandleVisibleChange", "onHandleChange"]))
                              : (_openBlock(), _createBlock(_component_miezz_input, {
                                  key: 1,
                                  modelValue: row.ContainerNo,
                                  "onUpdate:modelValue": ($event: any) => ((row.ContainerNo) = $event),
                                  pattern: "[0-9a-z]",
                                  upperCase: true,
                                  onHandleBlur: ($event: any) => (_ctx.handleContainerTrailerChange(row, 'Vgm', index))
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "onHandleBlur"]))
                          ]),
                          _: 2
                        }, 1032, ["prop", "rules"]))
                      : (model.Prop == 'SealNo')
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 1,
                            prop: `DetailVgms[${index}]`,
                            rules: _ctx.form.Rules.DetailVgms_SealNo,
                            "label-width": "0px"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_miezz_input, {
                                modelValue: row.SealNo,
                                "onUpdate:modelValue": ($event: any) => ((row.SealNo) = $event),
                                red: _ctx.addDeparturePortBookingManifestVgm,
                                disabled: !row.ContainerNo,
                                onHandleBlur: ($event: any) => (_ctx.handleSyncContainer(row, 'Vgm', index))
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "red", "disabled", "onHandleBlur"])
                            ]),
                            _: 2
                          }, 1032, ["prop", "rules"]))
                        : (model.Prop == 'ContainerTypeId')
                          ? (_openBlock(), _createBlock(_component_el_form_item, {
                              key: 2,
                              prop: `DetailVgms[${index}].ContainerTypeId`,
                              rules: _ctx.form.Rules.DetailVgms_ContainerTypeId,
                              "label-width": "0px"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_miezz_select, {
                                  modelValue: row.ContainerTypeId,
                                  "onUpdate:modelValue": ($event: any) => ((row.ContainerTypeId) = $event),
                                  label: row.ContainerTypeLabel,
                                  "onUpdate:label": ($event: any) => ((row.ContainerTypeLabel) = $event),
                                  options: _ctx.containerTypes,
                                  red: _ctx.addDeparturePortBookingManifestVgm,
                                  labelKey: "Data.Iso",
                                  onHandleChange: ($event: any) => (_ctx.handleSyncContainer(row, 'Vgm', index))
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "onUpdate:label", "options", "red", "onHandleChange"])
                              ]),
                              _: 2
                            }, 1032, ["prop", "rules"]))
                          : (model.Prop == 'WeighingMethod')
                            ? (_openBlock(), _createBlock(_component_el_form_item, {
                                key: 3,
                                prop: `DetailVgms[${index}].WeighingMethod`,
                                "label-width": "0px"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_miezz_select, {
                                    modelValue: row.WeighingMethod,
                                    "onUpdate:modelValue": ($event: any) => ((row.WeighingMethod) = $event),
                                    options: _ctx.EnumWeighingMethodOption,
                                    clearable: false,
                                    onHandleChange: _cache[14] || (_cache[14] = ($event: any) => (_ctx.calcVgmWeight()))
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
                                ]),
                                _: 2
                              }, 1032, ["prop"]))
                            : (model.Prop == 'Weight')
                              ? (_openBlock(), _createBlock(_component_el_form_item, {
                                  key: 4,
                                  prop: `DetailVgms[${index}].Weight`,
                                  rules: _ctx.form.Rules.DetailVgms_Weight,
                                  "label-width": "0px"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_miezz_input, {
                                      modelValue: row.Weight,
                                      "onUpdate:modelValue": ($event: any) => ((row.Weight) = $event),
                                      pattern: "[0-9.]",
                                      number: true,
                                      numberFixed: 2
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 2
                                }, 1032, ["prop", "rules"]))
                              : (model.Prop == 'ResponsibleParty')
                                ? (_openBlock(), _createBlock(_component_el_form_item, {
                                    key: 5,
                                    prop: `DetailVgms[${index}].ResponsibleParty`,
                                    "label-width": "0px"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_miezz_input, {
                                        modelValue: row.ResponsibleParty,
                                        "onUpdate:modelValue": ($event: any) => ((row.ResponsibleParty) = $event),
                                        pattern: "[a-zA-Z ]",
                                        placeholder: "请填写英文",
                                        trim: false,
                                        trimManySpaceWhenChange: true,
                                        trimWhenBlur: true
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 2
                                  }, 1032, ["prop"]))
                                : (model.Prop == 'Sign')
                                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                                      key: 6,
                                      prop: `DetailVgms[${index}].Sign`,
                                      "label-width": "0px"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_miezz_input, {
                                          modelValue: row.Sign,
                                          "onUpdate:modelValue": ($event: any) => ((row.Sign) = $event),
                                          pattern: "[a-zA-Z]",
                                          placeholder: "请填写英文",
                                          trim: false,
                                          trimManySpaceWhenChange: true,
                                          trimWhenBlur: true
                                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                      ]),
                                      _: 2
                                    }, 1032, ["prop"]))
                                  : (model.Prop == 'Tel')
                                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                                        key: 7,
                                        prop: `DetailVgms[${index}].Tel`,
                                        "label-width": "0px"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_miezz_input, {
                                            modelValue: row.Tel,
                                            "onUpdate:modelValue": ($event: any) => ((row.Tel) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                        ]),
                                        _: 2
                                      }, 1032, ["prop"]))
                                    : (model.Prop == 'WeighingAddress')
                                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                                          key: 8,
                                          prop: `DetailVgms[${index}].WeighingAddress`,
                                          "label-width": "0px"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_miezz_input, {
                                              modelValue: row.WeighingAddress,
                                              "onUpdate:modelValue": ($event: any) => ((row.WeighingAddress) = $event),
                                              pattern: "[a-zA-Z]",
                                              placeholder: "请填写英文"
                                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                          ]),
                                          _: 2
                                        }, 1032, ["prop"]))
                                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["modelValue", "onHandleRowButtonClick"]),
                _createVNode(_component_miezz_button, {
                  model: _ctx.btnAddVgm,
                  onHandleClick: _ctx.handleClick
                }, null, 8, ["model", "onHandleClick"]),
                _createElementVNode("table", _hoisted_8, [
                  _hoisted_9,
                  _hoisted_10,
                  _createElementVNode("tr", null, [
                    _hoisted_11,
                    _hoisted_12,
                    _createElementVNode("td", null, [
                      _createVNode(_component_miezz_input, {
                        modelValue: _ctx.form.Data.ShipperCode,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.form.Data.ShipperCode) = $event)),
                        pattern: "[^\\u4e00-\\u9fa5]",
                        trimAll: true
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_13,
                    _createElementVNode("td", null, [
                      _createVNode(_component_miezz_input, {
                        modelValue: _ctx.form.Data.ShipperNameEn,
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.form.Data.ShipperNameEn) = $event)),
                        pattern: "[^\\u4e00-\\u9fa5]"
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_14,
                    _createElementVNode("td", null, [
                      _createVNode(_component_miezz_input, {
                        modelValue: _ctx.form.Data.ShipperAddressEn,
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.form.Data.ShipperAddressEn) = $event)),
                        pattern: "[^\\u4e00-\\u9fa5]"
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_15,
                    _createElementVNode("td", null, [
                      _createVNode(_component_miezz_select, {
                        modelValue: _ctx.form.Data.ShipperCountryCode,
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.form.Data.ShipperCountryCode) = $event)),
                        options: _ctx.countryCodes,
                        valueKey: "CountryCode",
                        labelKey: "CountryCode",
                        "fetch-suggestions": _ctx.getCountryCodes
                      }, null, 8, ["modelValue", "options", "fetch-suggestions"])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_16,
                    _createElementVNode("td", null, [
                      _createVNode(_component_miezz_input, {
                        modelValue: _ctx.form.Data.ShipperTel,
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.form.Data.ShipperTel) = $event)),
                        pattern: "[^\\u4e00-\\u9fa5]",
                        trimAll: true
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_17,
                    _createElementVNode("td", null, [
                      _createVNode(_component_miezz_input, {
                        modelValue: _ctx.form.Data.ShipperAeoCode,
                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.form.Data.ShipperAeoCode) = $event)),
                        pattern: "[^\\u4e00-\\u9fa5]",
                        trimAll: true
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _hoisted_18,
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_19, [
                      _createTextVNode(" 收货人"),
                      _hoisted_20,
                      _createTextVNode("（Consignee）"),
                      _hoisted_21,
                      _createVNode(_component_miezz_button, {
                        model: _ctx.btnCopyToNotifier,
                        onHandleClick: _ctx.handleClick
                      }, null, 8, ["model", "onHandleClick"])
                    ]),
                    _hoisted_22,
                    _createElementVNode("td", null, [
                      _createVNode(_component_miezz_input, {
                        modelValue: _ctx.form.Data.ConsigneeCode,
                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.form.Data.ConsigneeCode) = $event)),
                        pattern: "[^\\u4e00-\\u9fa5]",
                        trimAll: true
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_23,
                    _createElementVNode("td", null, [
                      _createVNode(_component_miezz_input, {
                        modelValue: _ctx.form.Data.ConsigneeNameEn,
                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.form.Data.ConsigneeNameEn) = $event)),
                        pattern: "[^\\u4e00-\\u9fa5]"
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_24,
                    _createElementVNode("td", null, [
                      _createVNode(_component_miezz_input, {
                        modelValue: _ctx.form.Data.ConsigneeAddressEn,
                        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.form.Data.ConsigneeAddressEn) = $event)),
                        pattern: "[^\\u4e00-\\u9fa5]"
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_25,
                    _createElementVNode("td", null, [
                      _createVNode(_component_miezz_select, {
                        modelValue: _ctx.form.Data.ConsigneeCountryCode,
                        "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.form.Data.ConsigneeCountryCode) = $event)),
                        options: _ctx.countryCodes,
                        valueKey: "CountryCode",
                        labelKey: "CountryCode",
                        "fetch-suggestions": _ctx.getCountryCodes
                      }, null, 8, ["modelValue", "options", "fetch-suggestions"])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_26,
                    _createElementVNode("td", null, [
                      _createVNode(_component_miezz_input, {
                        modelValue: _ctx.form.Data.ConsigneeTel,
                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.form.Data.ConsigneeTel) = $event)),
                        pattern: "[^\\u4e00-\\u9fa5]",
                        trimAll: true
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_27,
                    _createElementVNode("td", null, [
                      _createVNode(_component_miezz_input, {
                        modelValue: _ctx.form.Data.ConsigneeAeoCode,
                        "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.form.Data.ConsigneeAeoCode) = $event)),
                        pattern: "[^\\u4e00-\\u9fa5]",
                        trimAll: true
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_28,
                    _createElementVNode("td", null, [
                      _createVNode(_component_miezz_input, {
                        modelValue: _ctx.form.Data.ConsigneeContact,
                        "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.form.Data.ConsigneeContact) = $event)),
                        pattern: "[^\\u4e00-\\u9fa5]"
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_29,
                    _createElementVNode("td", null, [
                      _createVNode(_component_miezz_input, {
                        modelValue: _ctx.form.Data.ConsigneeContactNumber,
                        "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.form.Data.ConsigneeContactNumber) = $event)),
                        pattern: "[^\\u4e00-\\u9fa5]"
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _hoisted_30,
                  _createElementVNode("tr", null, [
                    _hoisted_31,
                    _hoisted_32,
                    _createElementVNode("td", null, [
                      _createVNode(_component_miezz_input, {
                        modelValue: _ctx.form.Data.NotifyPartyCode,
                        "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.form.Data.NotifyPartyCode) = $event)),
                        pattern: "[^\\u4e00-\\u9fa5]",
                        trimAll: true
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_33,
                    _createElementVNode("td", null, [
                      _createVNode(_component_miezz_input, {
                        modelValue: _ctx.form.Data.NotifyPartyNameEn,
                        "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.form.Data.NotifyPartyNameEn) = $event)),
                        pattern: "[^\\u4e00-\\u9fa5]"
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_34,
                    _createElementVNode("td", null, [
                      _createVNode(_component_miezz_input, {
                        modelValue: _ctx.form.Data.NotifyPartyAddressEn,
                        "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.form.Data.NotifyPartyAddressEn) = $event)),
                        pattern: "[^\\u4e00-\\u9fa5]"
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_35,
                    _createElementVNode("td", null, [
                      _createVNode(_component_miezz_select, {
                        modelValue: _ctx.form.Data.NotifyPartyCountryCode,
                        "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.form.Data.NotifyPartyCountryCode) = $event)),
                        options: _ctx.countryCodes,
                        valueKey: "CountryCode",
                        labelKey: "CountryCode",
                        "fetch-suggestions": _ctx.getCountryCodes
                      }, null, 8, ["modelValue", "options", "fetch-suggestions"])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_36,
                    _createElementVNode("td", null, [
                      _createVNode(_component_miezz_input, {
                        modelValue: _ctx.form.Data.NotifyPartyTel,
                        "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.form.Data.NotifyPartyTel) = $event)),
                        pattern: "[^\\u4e00-\\u9fa5]",
                        trimAll: true
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_37,
                    _createElementVNode("td", null, [
                      _createVNode(_component_miezz_input, {
                        modelValue: _ctx.form.Data.NotifyPartyAeoCode,
                        "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.form.Data.NotifyPartyAeoCode) = $event)),
                        pattern: "[^\\u4e00-\\u9fa5]",
                        trimAll: true
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["model", "rules"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["bottom-buttons", "onHandleFooterButtonClick"])), [
      [_directive_loading, _ctx.loading]
    ]),
    _createVNode(_component_miezz_hscode, {
      ref: "HsCode",
      onOnSelectHsCode: _ctx.onSelectHsCode
    }, null, 8, ["onOnSelectHsCode"]),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalWeighingMethod,
      "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.modalWeighingMethod) = $event))
    }, {
      default: _withCtx(() => [
        _hoisted_38,
        _hoisted_39,
        _hoisted_40,
        _hoisted_41,
        _hoisted_42
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalCrossMixing,
      "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.modalCrossMixing) = $event))
    }, {
      default: _withCtx(() => [
        _hoisted_43
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}